import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { apiSciScoreClient } from '@utils/api/base';
import { AppThunk } from '../store';
import { ProductL } from '../type';

export interface Products {
  errors: Array<string>;
  limit?: number;
  size?: number;
  start_after?: number;
  continues: boolean;
  data: ProductL[];
}

let initialState: Products = {
  errors: [],
  continues: false,
  data: [],
};

const productSlice = createSlice({
  name: 'products',
  initialState: initialState,
  reducers: {
    addOne: (state, { payload }: PayloadAction<ProductL>) => {
      state.data.push(payload);
    },
    // addMany: (state, action: PayloadAction<Compound2[]>) => {
    //   state.data.push(...action.payload);
    // },
    replace: (state, action: PayloadAction<ProductL[]>) => {
      state.data = action.payload;
    },
    // update: (state, { payload }: PayloadAction<SubmissionL>) => {
    //   const cmpToUpdate = state.data.find((cmp) => cmp._id === payload._id);
    //   if (cmpToUpdate) {
    //     const { path, value } = payload;
    //     _.set(cmpToUpdate, path, value);
    //   }
    // },
  },
});

export const { addOne, replace } = productSlice.actions;

export default productSlice.reducer;

export const getProducts =
  (page: number = 0): AppThunk =>
  async (dispatch) => {
    try {
      const { data } = await apiSciScoreClient.get('/product/');
      console.log(data);
      dispatch(replace(data.data));
    } catch (err) {
      console.error('getProducts Failed: ', err);
    }
  };

export const checkCredits = async (dispatch) => {
  try {
    const { data } = await apiSciScoreClient.get('/order/credits');
    //console.log(data);
    dispatch(replace(data.data));
  } catch (err) {
    console.error('checkCredits Failed: ', err);
  }
};
